module.exports = __webpack_public_path__ + "static/media/play_effect_selected_item.51830ae2.png";